module.exports = __webpack_public_path__ + "static/media/attach.6d1688ef.svg";